import { render } from "./GroupBuyListPage.vue?vue&type=template&id=8d8150ec"
import script from "./GroupBuyListPage.vue?vue&type=script&lang=js"
export * from "./GroupBuyListPage.vue?vue&type=script&lang=js"
script.render = render

export default script